function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3a1 1 0 011-1h6a1 1 0 011 1v26a1 1 0 01-1 1h-6a1 1 0 01-1-1V3zm2 25V4h4v24h-4zM23 11a1 1 0 00-1 1v17a1 1 0 001 1h6a1 1 0 001-1V12a1 1 0 00-1-1h-6zm1 2v15h4V13h-4zM3 18a1 1 0 00-1 1v10a1 1 0 001 1h6a1 1 0 001-1V19a1 1 0 00-1-1H3zm1 2v8h4v-8H4z",
  fill: "currentColor"
})));